<template>
  <div v-if="pdfUrl && !documentSigned && !documentUpdated">
    <iframe
        :src="pdfUrl"
        style="width: 100%; height: 1000px; border: none;"
    ></iframe>

    <div style="width: 100%; text-align: right; margin-top: 20px;" v-if="pdfUrl">
      <button
          type="button"
          class="btn btn-primary"
          @click="handleButtonClick"
      >
        <span>
          {{ $t('skr_btn') }}
        </span>
      </button>

      <SkribblePopup
          :show="showPopup"
          @cancel="showPopup = false"
          @continue="sendForSigning"
      />
    </div>
  </div>

  <div v-else-if="documentUpdated" class="p-4 text-center">
    <h3 class="text-primary text-large">{{ $t('skr_framework_agreement_updated') }}</h3>
  </div>

  <div v-else-if="documentSigned" class="p-4 text-center">
    <h3 class="text-success text-large">{{ $t('skr_invoice_document_signed') }}</h3>
  </div>

  <div v-else class="col-12">
    <img src="/new-loader.svg" alt="loader"/>
  </div>
</template>

<script>
export default {
  name: 'SkribbleFrameworkAgreement',
  data() {
    return {
      error: null,
      country: '',
      form: {},
      showPopup: false,
      invalidFields: {},
      pollInterval: null,
      documentSigned: false,
      pdfUrl: null,
      pdfPath: null,
      documentUpdated: false
    }
  },
  async created() {
    const user = await this.refreshUser();
    const company = user.company || {};
    let countryName = user.country.name;
    this.country = countryName;

    const address = [
      [user.address, user.address_nr].filter(Boolean).join(', '),
      [user.zip, user.city].filter(Boolean).join(' ')
    ].filter(Boolean).join(', ');

    this.form = {
      sign_first: user.first_name || '',
      sign_last: user.last_name || '',
      sign_address: countryName ? this.formatAddress([address, countryName]) : (address || ''),
      lang: this.$i18n.locale || 'de',
      userID: user.id || '',
      companyID: company.id || '',
      institution_name: company.name || '',
      institution_address: this.formatAddress([
        company.address,
        company.address_nr,
        [company.zip, company.city].filter(Boolean).join(' ')
      ]),
      institution_uid: company.uid || '',
      sign_position: user.position || ''
    };
    this.checkSigningStatus();
    await this.generateFrameworkAgreement(this.form);
  },

  methods: {
    formatAddress(parts) {
      return parts.filter(Boolean).join(', ') || '';
    },
    async refreshUser() {
      try {
        let user = this.$store.state.auth.user;
        const { data } = await this.$http.post(`/getUserDataWithId/${user.id}`);

        if (data && data.value) {
          this.$store.commit("auth/setUser", data.value);
          return data.value;
        } else {
          console.warn("No user returned from backend");
          return user;
        }
      } catch (err) {
        console.error("Failed to refresh user:", err);
        return this.$store.state.auth.user;
      }
    },

    async generateFrameworkAgreement(prefillData) {
      this.disableSell = true;

      try {
        const res = await this.$http.post('/skribble/framework-agreement/generate-pdf', prefillData);
        this.pdfUrl = res.data.value.pdf_url;
        this.pdfPath = res.data.value.pdf_path ?? '';

      } catch (err) {
        console.error(err);
      }
    },

    async sendForSigning() {
      this.showPopup = false;
      const payload = { form: this.form, form_type: 'framework_agreement_investor', pdfPath: this.pdfPath }
      const res = await this.$http.post('/skribble/send-for-signing', payload )
      const signingUrl = res?.data?.value?.signing_url || null

      if (!signingUrl) {
        this.error = "Internal server error";
      } else if (signingUrl) {
        this.signing_url = signingUrl;
        window.open(this.signing_url, "_blank");
        this.pollInterval = setInterval(this.checkSigningStatus, 10000)
      }
    },

    handleButtonClick() {
      if (localStorage.getItem("hideSkribblePopup") === "true") {
        this.sendForSigning();
      } else {
        this.showPopup = true;
      }
    },

    checkSigningStatus() {
      this.$http.post(`/skribble/check-status/${this.form.userID}/framework_agreement_investor`).then((res) => {
        if (res.data?.value === 'SIGNED') {
          clearInterval(this.pollInterval)
          this.documentUpdated = false;
          this.pollInterval = null

          this.$http.post('company/tasks/changeStatus/').then((response) => {
            if (response.data.value) {
              window.location.reload()
            }
          })

        } else if ( res.data?.value === "UPDATED") {
            this.documentUpdated = true;
        }
      }).catch(err => {
        console.error('Error checking signing status', err)
      });
    }
  }
}
</script>

<style scoped>

</style>
